import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { BASE_URL } from './Config/Config';

function Categories() {
  const [aboutData, setAboutData] = useState(null);
  const experienceTexts = ['2', ' ', '4', '+', ' ', 'Y', 'E', 'A', 'R', 'S', ' ', 'E', 'X', 'P', 'E', 'R', 'I', 'E', 'N', 'C', 'E', ' '];

  useEffect(() => {
    fetch(`${BASE_URL}/AboutUs/`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.data?.length > 0) {
          setAboutData(data.data[0]);
        }
      })
      .catch((err) => console.error('Error fetching AboutUs data:', err));
  }, []);

  return (
    <div className="overflow-hidden space" id="about-sec">
      {/* Decorative Shapes */}
      <div className="shape-mockup jump d-md-block d-none" data-right={0} data-bottom="10%">
        <img src="/assets/img/normal/about_2_shape1.png" alt="shapes" />
      </div>
      <div className="shape-mockup jump d-md-block d-none" data-right="76px" data-bottom="10%">
        <img src="/assets/img/normal/about_1_shape1.png" alt="shapes" />
      </div>

      <div className="container-fluid">
        <div className="row">
          
          {/* LEFT: Images */}
          <div className="col-xl-6 mb-50 mb-xl-0">
            <div className="img-box2 ">
              <div className="img1">
                <img
                  src={aboutData ? `${BASE_URL}${aboutData.AboutUs_Home_Image1}` : "/assets/img/about_img.jpg"}
                  alt="About US Auratech Academy"
                />
              </div>
              <div className="img2 tilt-active">
                <img
                  src={aboutData ? `https://api.auratechacademy.com${aboutData.AboutUs_Home_Image2}` : "/assets/img/about_traning.jpg"}
                  alt="About Auratech Academy"
                />
              </div>

              {/* Student Count Section */}
              <div className="tilt-active shape-mockup student-count jump">
                <h5 className="title">
                  <span className="text-theme">
                    <span className="counter-number">{aboutData?.Active_students}</span>
                  </span>
                </h5>
                <img src={aboutData ? `${BASE_URL}${aboutData?.AboutUs_Home_Image3}` : '/assets/img/about/student_pics.png'} alt="img" />
              </div>

              {/* Experience Section */}
              <div className="about-experience-wrap" style={{ zIndex: 2 ,transform: 'translateY(5px)' }}>
                <div className="about-experience-icon">
                  <img src="/assets/img/icon/AA-Favicon.png" alt="img" />
                </div>

                <div className="about-experience-tag">
                  {experienceTexts.map((text, index) => (
                    <span key={index} className="about-title-anime">
                      <span className={`char${index}`}>{text}</span>
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT: Text Content */}
          <div className="col-xl-6">
            <div className="about2-title-wrap">
              <div className="title-area mb-30">
                <span className="sub-title">
                  <i className="fal fa-book me-2" />
                  {aboutData?.AboutUs_Top_Line || 'Get to Know About Us'}
                </span>
                <h2 className="sec-title">
                  {aboutData?.AboutUs_heading || 'Welcome to Auratech Academy'}
                </h2>
              </div>

              <p className="mt-n2 mb-35">
                {aboutData?.AboutUs_Home_Description || 'Auratech Academy, established in 2008...'}
              </p>

             <div className="checklist style2 mb-45">
  <ul>
    {aboutData?.highlight_1 && <li>{aboutData.highlight_1}</li>}
    {aboutData?.highlight_2 && <li>{aboutData.highlight_2}</li>}
    {aboutData?.highlight_3 && <li>{aboutData.highlight_3}</li>}
    {aboutData?.highlight_4 && <li>{aboutData.highlight_4}</li>}
  </ul>
</div>

              
{aboutData?.AboutUs_More_Button === 1 && (
  <NavLink to={aboutData.AboutUs_More_Button_link} className="th-btn">
    {aboutData.AboutUs_More_Button_text} <i className="far fa-arrow-right ms-2" />
  </NavLink>
)}

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Categories;
